import React from "react";

const LovMenu = ({ show, data, onClose, onSelect }) => {
  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Pilih Menu</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <table className="table table-bordered table-hover table-sm">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Menu</th>
                  <th>File Name</th>
                  <th>Brand</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ? (
                  data.map((m, idx) => (
                    <tr key={idx}>
                      <td>{m.menu_id}</td>
                      <td>{m.menu_desc}</td>
                      <td>{m.file_name}</td>
                      <td>{m.brand_id}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => onSelect(m)}
                        >
                          Pilih
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Tidak ada data menu
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LovMenu;
